module.exports = __webpack_public_path__ + "media/images/polygon-2@2x-93602877dfa0ddd30c4ea7824218b1d7.png";